export class RemoveIssueStateError extends Error {
    
}